import appContent from '@/services/content/appContent.typed';
import stringUtils from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

type AutoDeliveryDcxOrderLabelProps = {
    orderId: string;
    className?: string;
};

const AutoDeliveryDcxOrderLabel = ({orderId, className}: AutoDeliveryDcxOrderLabelProps) => {
    const {orderLabel} = appContent.getAutoDeliveryContent()?.dashboardContent || {};

    if (!orderLabel) return null;

    return (
        <span
            className={twx('text-14 leading-[20px] tracking-02', className)}
            dangerouslySetInnerHTML={{__html: stringUtils.formatString(orderLabel, orderId)}}
        />
    );
};

export default AutoDeliveryDcxOrderLabel;
